import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";

import ImageWithBasePath from "../../../../core/img/imagewithbasebath";

import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import CommonDeleteModal from "../../../../core/common/modal/commonDeleteModal";
// import { Edit } from "feather-icons-react/build/IconComponents";

import { Avatar, Select, Spin, Tooltip } from "antd";
import dayjs from "dayjs";
import NewProject from "./NewProject";
import { BASE_CRM_URL } from "../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import UpdateProject from "./UpdateProject";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const CRMProjects = () => {
  const [exportLoading, setExportLoading] = useState(false);

  const [projectStatusOptions, setProjectStatusOptions] = useState([]);

  const getProjectStatuses = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}project/GetProjectStatus`);

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.Status,
        }));

        setProjectStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const projectStatusCards = [
    {
      key: "New",
      label: "New",
      status: 1,
      icon: "fa-regular fa-circle-pause",
      iconClass: "bg-secondary bg-opacity-10 text-secondary",
    },
    {
      key: "InProgress",
      label: "In Progress",
      status: 2,
      icon: "fa-solid fa-spinner",
      iconClass: "bg-info bg-opacity-10 text-primary",
    },
    {
      key: "OnHold",
      label: "On Hold",
      status: 3,
      icon: "fa-solid fa-circle-pause",
      iconClass: "bg-warning bg-opacity-10 text-warning",
    },
    {
      key: "Finished",
      label: "Finished",
      status: 4,
      icon: "fa-solid fa-circle-check",
      iconClass: "bg-success bg-opacity-10 text-success",
    },
    {
      key: "Cancelled",
      label: "Cancelled",
      status: 5,
      icon: "fa-solid fa-circle-xmark",
      iconClass: "bg-danger bg-opacity-10 text-danger",
    },
  ];

  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (text, record) => {
        const name = text?.trim() || "N/A";
        const displayName =
          name.length > 30 ? `${name.substring(0, 30)}...` : name;

        return name === "N/A" ? (
          <span className="text-muted">N/A</span>
        ) : (
          <Link to={`/crm/projectview/${record.id}`} title={name}>
            {displayName}
          </Link>
        );
      },
    },
    {
      title: "Customer",
      dataIndex: "company",
      sorter: (a, b) => (a.company || "").localeCompare(b.company || ""),
      render: (text) => {
        const company = text?.trim() || "N/A";
        const displayCompany =
          company.length > 30 ? `${company.substring(0, 30)}...` : company;

        return <span title={company}>{displayCompany}</span>;
      },
    },

    {
      title: "Start Date",
      dataIndex: "start_date",
      sorter: (a, b) => {
        const dateA = a.start_date ? dayjs(a.start_date).valueOf() : 0;
        const dateB = b.start_date ? dayjs(b.start_date).valueOf() : 0;

        return dateA - dateB;
      },
      render: (date) => (
        <div>
          <i className="fa-solid fa-calendar-days text-primary me-2"></i>
          {date ? dayjs(date).format("DD-MM-YYYY") : "-"}
        </div>
      ),
    },

    {
      title: "Deadline",
      dataIndex: "deadline",
      sorter: (a, b) => {
        const dateA = a.deadline ? dayjs(a.deadline).valueOf() : 0;
        const dateB = b.deadline ? dayjs(b.deadline).valueOf() : 0;

        return dateA - dateB;
      },
      render: (date) => {
        if (!date) return "-";

        const formattedDate = dayjs(date).format("DD-MM-YYYY");
        const due = dayjs(date);
        const days = due.startOf("day").diff(dayjs().startOf("day"), "day");

        return (
          <>
            <div>
              <i className="fa-solid fa-hourglass-half me-2 text-danger"></i>
              {formattedDate}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 7
                    ? "text-warning"
                    : "text-success"
              }
            >
              <i className="fa-regular fa-clock me-1"></i>

              {days < 0
                ? `${Math.abs(days)} Days Overdue`
                : `${days} Days Left`}
            </small>
          </>
        );
      },
    },
    {
      title: "Members",
      dataIndex: "staff",

      render: (_, record) => {
        const staffMembers = (record.staff || []).filter(
          (member) => member?.staff_name,
        );

        if (staffMembers.length === 0) {
          return <span className="text-muted">N/A</span>;
        }

        return (
          <Avatar.Group
            max={{
              count: 3,
              style: {
                backgroundColor: "#f56a00",
                color: "#fff",
              },
            }}
          >
            {staffMembers.map((member, index) => {
              const name = member.staff_name;

              const initials = name
                .trim()
                .split(/\s+/)
                .map((x) => x[0])
                .join("")
                .toUpperCase();

              const avatarStyles = [
                { bg: "#E7F1FF", color: "#0D6EFD" },
                { bg: "#E8F8F0", color: "#198754" },
                { bg: "#FFF4E5", color: "#FD7E14" },
                { bg: "#F3E8FF", color: "#6F42C1" },
                { bg: "#E6FFFB", color: "#0DCAF0" },
                { bg: "#FCE7F3", color: "#D63384" },
              ];

              const style = avatarStyles[index % avatarStyles.length];

              return (
                <Tooltip key={member.staff_id} title={name} placement="top">
                  <Avatar
                    style={{
                      backgroundColor: style.bg,
                      color: style.color,
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    {initials}
                  </Avatar>
                </Tooltip>
              );
            })}
          </Avatar.Group>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "New":
              return "#6c757d";

            case "InProgress":
              return "#0d6efd";

            case "On Hold":
              return "#ffc107";

            case "Finished":
              return "#198754";

            case "Cancelled":
              return "#dc3545";

            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              projectStatusOptions.find(
                (item) => item.label === (text || "New"),
              )?.value
            }
            style={{ width: 120 }}
            options={projectStatusOptions}
            onChange={(value) => {
              updateInvoiceStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = projectStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",
      width: 90,
      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/projectview/${record.id}`}
                className="dropdown-item"
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                className="dropdown-item"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditProject(record);
                }}
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                className="me-2 p-2 shadow-sm"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditProject(record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [projects, setProjects] = useState([]);
  const [projectCounts, setProjectCounts] = useState({
    New: 0,
    InProgress: 0,
    OnHold: 0,
    Finished: 0,
    Cancelled: 0,
  });

  const [selectedStatus, setSelectedStatus] = useState(0);
  const [loading, setLoading] = useState(false);

  const [openProject, setOpenProject] = useState(false);
  console.log(projects, "projectssssssssssss");

  const fetchProjectCounts = async () => {
    try {
      const response = await axios.get(
        `${BASE_CRM_URL}project/GetProjectCounts`,
      );

      if (response.data?.Status) {
        const result = response.data.ResultData || [];

        const counts = {
          New: 0,
          InProgress: 0,
          OnHold: 0,
          Finished: 0,
          Cancelled: 0,
        };

        result.forEach((item) => {
          switch (Number(item.Id)) {
            case 1:
              counts.New = Number(item.TotalCount) || 0;
              break;

            case 2:
              counts.InProgress = Number(item.TotalCount) || 0;
              break;

            case 3:
              counts.OnHold = Number(item.TotalCount) || 0;
              break;

            case 4:
              counts.Finished = Number(item.TotalCount) || 0;
              break;

            case 5:
              counts.Cancelled = Number(item.TotalCount) || 0;
              break;

            default:
              break;
          }
        });

        console.log("Final Counts:", counts);

        setProjectCounts(counts);
      }
    } catch (error) {
      console.error("Error fetching project counts:", error);
    }
  };

  const fetchProjects = async (status = 0) => {
    try {
      setLoading(true);

      const params = status !== 0 ? { status } : {};

      const response = await axios.get(`${BASE_CRM_URL}project/GetProjects`, {
        params,
      });

      if (response.data?.Status) {
        const data = response.data.ResultData || [];
        setProjects(data);
      } else {
        setProjects([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const updateInvoiceStatus = async (ProjectId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}project/UpdateProjectStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: ProjectId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchProjects();
        fetchProjectCounts();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProjectCounts();
    fetchProjects(0);
    getProjectStatuses();
  }, []);

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    fetchProjects(status);
  };

  const [editProjectOpen, setEditProjectOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleEditProject = (record) => {
    setSelectedProject(record);
    setEditProjectOpen(true);
  };

  const handleCloseEditProject = () => {
    setEditProjectOpen(false);
    setSelectedProject(null);
  };

  const exportProjectsExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Projects");

      // Columns
      worksheet.columns = [
        {
          header: "Project Name",
          key: "name",
          width: 25,
        },
        {
          header: "Company",
          key: "company",
          width: 25,
        },
        {
          header: "Description",
          key: "description",
          width: 40,
        },

        {
          header: "Project Created",
          key: "project_created",
          width: 22,
        },
        {
          header: "Start Date",
          key: "start_date",
          width: 22,
        },
        {
          header: "Deadline",
          key: "deadline",
          width: 22,
        },
        {
          header: "Status",
          key: "StatusName",
          width: 18,
        },
        {
          header: "Staff",
          key: "staff",
          width: 30,
        },
      ];

      // Add data
      projects.forEach((project) => {
        worksheet.addRow({
          id: project.id ?? "",
          name: project.name ?? "",
          company: project.company ?? "",
          description: project.description ?? "",
          clientid: project.clientid ?? "",

          project_created: project.project_created
            ? new Date(project.project_created).toLocaleString("en-IN")
            : "",

          start_date: project.start_date
            ? new Date(project.start_date).toLocaleString("en-IN")
            : "",

          deadline: project.deadline
            ? new Date(project.deadline).toLocaleString("en-IN")
            : "",

          StatusName: project.StatusName ?? "",

          staff: Array.isArray(project.staff)
            ? project.staff
                .map((staff) => staff.staff_name)
                .filter(Boolean)
                .join(", ")
            : "",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      // Borders
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate file
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Projects.xlsx");
    } catch (error) {
      console.error("Projects Excel export error:", error);

      Swal.fire("Error", "Failed to generate Projects Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportProjectsPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Project Name",
        "Company",
        "Description",
        "Project Created",
        "Start Date",
        "Deadline",
        "Status",
        "Staff",
      ];

      const rows = projects.map((project) => [
        project.name ?? "",
        project.company ?? "",
        project.description ?? "",

        project.project_created
          ? new Date(project.project_created).toLocaleString("en-IN")
          : "",

        project.start_date
          ? new Date(project.start_date).toLocaleString("en-IN")
          : "",

        project.deadline
          ? new Date(project.deadline).toLocaleString("en-IN")
          : "",

        project.StatusName ?? "",

        Array.isArray(project.staff)
          ? project.staff
              .map((staff) => staff.staff_name)
              .filter(Boolean)
              .join(", ")
          : "",
      ]);

      // Report name - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Projects Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        didDrawPage: () => {
          // Footer center
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Correct Page X of Y
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Projects.pdf");
    } catch (error) {
      console.error("Projects PDF export error:", error);

      Swal.fire("Error", "Failed to generate Projects PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        {exportLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/crm/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Projects
                    </h4>
                  </ol>
                </nav>
                <p className="text-muted">Manage and add new Projects</p>
              </div>
            </div>
            <ul className="table-top-head">
              <li className="me-2">
                <Link onClick={exportProjectsPDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </li>
              <li className="me-2">
                <Link onClick={exportProjectsExcel}>
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </li>{" "}
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-success btn-sm me-2"
                onClick={() => setOpenProject(true)}
              >
                <i className="ti ti-circle-plus fs-4 "> </i>
              </Link>
              {/* <Link
                to="#"
                className="btn btn-dark"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasAddUserToPackage"
              >
                <PlusCircle data-feather="plus-circle" className=" me-1" />
                Package
              </Link> */}
            </div>
          </div>

          <div className="row g-3">
            {projectStatusCards.map((item) => (
              <div className="col-12 col-md-6 col-lg d-flex" key={item.key}>
                <div
                  className={`card shadow-sm revenue-widget flex-fill border ${
                    selectedStatus === item.status ? "border-primary" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleStatusClick(item.status)}
                >
                  <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                    <div className="d-flex align-items-center gap-2 text-nowrap">
                      <h4 className="mb-0 fw-bold">
                        {projectCounts[item.key]}
                      </h4>

                      <p className="mb-0 fw-semibold">{item.label}</p>
                    </div>
                    <div
                      className={`rounded-circle  ${item.iconClass} bg-opacity-10 d-flex align-items-center justify-content-center`}
                      style={{ width: 45, height: 45 }}
                    >
                      <i className={`${item.icon} fs-4`}></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* /product list */}
          <div className="card table-list-card ">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Select
                    placeholder="Status"
                    style={{ width: 150 }}
                    value={selectedStatus}
                    onChange={(value) => {
                      setSelectedStatus(value);
                      fetchProjects(value);
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All",
                      },
                      ...projectStatusCards.map((item) => ({
                        value: item.status,
                        label: item.label,
                      })),
                    ]}
                  />
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className=" table-responsive">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px", // adjust height if needed
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <Table columns={columns} dataSource={projects} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <NewProject
          open={openProject}
          onClose={() => setOpenProject(false)}
          onSuccess={() => {
            fetchProjects(selectedStatus);
          }}
        />

        <UpdateProject
          open={editProjectOpen}
          onClose={handleCloseEditProject}
          getProjects={fetchProjects}
          record={selectedProject}
        />

        <CommonFooter />
      </div>
      <CommonDeleteModal />
    </div>
  );
};

export default CRMProjects;
